import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import Cookies from 'js-cookie';
import "./subscription_plan.css";
import { SubscriptionContext } from '../../reducers/SubscriptionContext';

const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
  const { refreshSubscription } = useContext(SubscriptionContext);

  const planDetails = {
    MONTHLY: { name: "Monthly Plan", amount: 99 },
    YEARLY: { name: "Yearly Plan", amount: 499 }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    // Poll every 100ms until window.Razorpay is available
    const checkInterval = setInterval(() => {
      if (window.Razorpay) {
        setRazorpayLoaded(true);
        clearInterval(checkInterval);
      }
    }, 100);

    // Optional timeout after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(checkInterval);
      if (!window.Razorpay) {
        console.error("Razorpay failed to load within timeout");
      }
    }, 10000);

    return () => {
      clearInterval(checkInterval);
      clearTimeout(timeout);
    };
  }, []);



  const handleProceedToPayment = async () => {
    
    if (!selectedPlan) {
      alert("Please select a plan!");
      return;
    }
    //console.log("Razorpay Loaded?", razorpayLoaded);
    //console.log("window.Razorpay", window.Razorpay);

    if (!razorpayLoaded || typeof window.Razorpay !== "function") {
      alert("Payment gateway is still loading. Please wait a moment and try again.");
      return;
    }


    try {
      setLoading(true);
      const planId = selectedPlan.toLowerCase();

      const getToken = async () => {
        try {
          const user = await Auth.currentAuthenticatedUser();
          const session = await Auth.currentSession();
          // const accessToken = session.getAccessToken();
          // const jwt = accessToken.getJwtToken();
          const jwt = session.getIdToken().getJwtToken();
          const username = user.username.includes("Google_")
            ? user.attributes.email
            : user.username;
          const email = user.attributes.email;

          return [username, jwt, email]; //  Return both values
        } catch (error) {
          // console.log("Auth error:", error);
          await Auth.signOut();
          return [null, null]; // Fallback return
        }
      };

      const [username, jwt, email] = await getToken(); 

      if (!username || !jwt) return; // Prevent call if something failed
      console.log("Username:", username);
      
      const response = await fetch("https://api.quizwizard.net/quiz/razorpay_order_api", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': jwt,
        },
        body: JSON.stringify({
          plan_id: planId,
          // amount: planDetails[selectedPlan].amount * 100, // Convert ₹ to paise
          username: username,
          email: email,
        })
      });
      // console.log("Response:", response); //  Debugging line
      const data = await response.json();

      if (!data.order_id) throw new Error("Order creation failed");

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: data.amount,
        currency: "INR",
        name: "Gencoft Technologies",
        description: `${planDetails[selectedPlan].name} Subscription Payment`,
        order_id: data.order_id,
        handler: async function (response) {
          // console.log("Payment Success Response: ", response);
          if (!response.razorpay_payment_id) {
            alert("Payment verification failed.");
            return;
          }
          //  Refresh subscription context
          await refreshSubscription();
          // alert("Payment successful!");
          Cookies.set('questionsPracticed', 0); // Reset cookie to 0
          history.push("/practiceevents");
        },
        theme: { color: "#3399cc" }
      };

      const razorpayInstance = new window.Razorpay(options);
      razorpayInstance.open();

    } catch (error) {
      alert("Payment failed, please try again.");
      // console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="plan-wrapper">
      <h1 className="plan-heading">Choose Your Plan</h1>
      <p className="plan-subtitle">Upgrade to unlock unlimited access</p>

      <div className="plan-grid">
        {["MONTHLY", "YEARLY"].map((planType) => (
          <div
            key={planType}
            className={`plan-card ${selectedPlan === planType ? "selected" : ""}`}
            onClick={() => setSelectedPlan(planType)}
          >
            {planType === "YEARLY" && (
              <div className="ribbon">
                <span>Best Value</span>
              </div>
            )}
            <h2>{planDetails[planType].name}</h2>
            <p className="price">₹{planDetails[planType].amount} {planType === "MONTHLY" ? "/mo" : "/yr"}</p>
          </div>
        ))}
      </div>

      <div className="plan-actions">
        <button
          className="pay-btn"
          disabled={!selectedPlan || loading}
          onClick={handleProceedToPayment}
        >
          {loading ? "Processing..." : "Proceed to Payment"}
        </button>
      </div>
    </div>



  );
};

export default SubscriptionPage;